import {useState} from 'react';
import {ReactComponent as BarIcon} from '../../assets/chart/bar.svg';
import {ReactComponent as BarActiveIcon} from '../../assets/chart/bar-active.svg';
import {ReactComponent as LineIcon} from '../../assets/chart/line.svg';
import {ReactComponent as LineActiveIcon} from '../../assets/chart/line-active.svg';
import {ReactComponent as ResetIcon} from '../../assets/chart/reset.svg';
import {ReactComponent as ArrowDownIcon} from '../../assets/common/arrow-down.svg';
import {ReactComponent as ArrowUpIcon} from '../../assets/common/arrow-up.svg';
import styles from './styles/detail.module.css';

export default function SettingDetail({ yAxisList, filteredYAxisList, index, setting, updateSetting }) {
    const [openDropdown, setOpenDropdown] = useState({
        variable: false,
        standard: false
    });

    const [variable, setVariable] = useState(setting.variable);
    const [chartType, setChartType] = useState(setting.chartType);
    const [standard, setStandard] = useState(setting.standard);

    const toggleDropdown = (type) => {
        setOpenDropdown((prevState) => ({
            ...prevState,
            [type]: !prevState[type]
        }));
    };

    const closeDropdown = (type) => {
        setOpenDropdown((prevState) => ({
            ...prevState,
            [type]: false
        }));
    };

    const resetVariable = () => {
        closeDropdown('variable');
        setVariable('');
        updateSetting(index, { ...setting, variable: '' });
    };

    const changeVariable = (newVariable) => {
        closeDropdown('variable');
        setVariable(newVariable.displayKey);
        updateSetting(index, { ...setting, variable: newVariable.displayKey });
    };

    const changeChartType = (newChartType) => {
        setChartType(newChartType);
        updateSetting(index, { ...setting, chartType: newChartType });
    };

    const changeStandard = (newStandard) => {
        closeDropdown('standard');
        setStandard(newStandard.displayKey);
        updateSetting(index, { ...setting, standard: newStandard.displayKey });
    };

    return (
        <div className={styles.wrapper}>
            <div>
                <button className={styles.btnDropdown} onClick={() => toggleDropdown('variable')}>
                    <p>{variable || '변수'}</p>
                    {openDropdown.variable ? <ArrowUpIcon/> : <ArrowDownIcon/>}
                </button>
                {openDropdown.variable &&
                    <ul>
                        {filteredYAxisList().map((axis) => (
                            <li key={axis} onClick={() => changeVariable(axis)}>
                                {axis.displayKey}
                            </li>
                        ))}
                        <li className={styles.reset} onClick={resetVariable}>초기화 <ResetIcon/></li>
                    </ul>
                }
            </div>
            <div className={styles.boxBtn}>
                <button className={`${styles.btnInactive} ${chartType === 'bar' ? styles.btnActive : ''}`}
                        onClick={() => changeChartType('bar')}
                >
                    {chartType === 'bar' ? <BarActiveIcon/> : <BarIcon/>}
                </button>
                <button className={`${styles.btnInactive} ${chartType === 'line' ? styles.btnActive : ''}`}
                        onClick={() => changeChartType('line')}
                >
                    {chartType === 'line' ? <LineActiveIcon/> : <LineIcon/>}
                </button>
            </div>
            <div>
                <button className={styles.btnDropdown} onClick={() => toggleDropdown('standard')}>
                    <p>{standard || '기준'}</p>
                    {openDropdown.standard ? <ArrowUpIcon/> : <ArrowDownIcon/>}
                </button>
                {openDropdown.standard &&
                    <ul>
                        {yAxisList.map((axis) => (
                            <li key={axis} onClick={() => changeStandard(axis)}>
                                {axis.displayKey}
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    );
}
